export const SEGMENT_COL = 'Segment';
export const EMAIL_LIST_ID_COL = 'EmailListName';
export const SEGMENT_CARDINALITY_LIMIT = 249;

export const EMAIL_OPEN_RATE = 'Email Open Rate';
export const OPEN_RATE = 'Open Rate';
export const SEGMENT_METRIC_NAME_EXCEPTIONS = [EMAIL_OPEN_RATE, OPEN_RATE];
export const SEGMENT_METRIC_DEF_EXCEPTIONS: {
  [metricName: string]: { definition: string; learnMoreLink: string; bannerName: string };
} = {
  [EMAIL_OPEN_RATE]: {
    definition:
      'Percent of emails opened. For segment data, calculated as Email Opens (one per messageId) / (Total Emails Delivered)',
    learnMoreLink: '',
    bannerName: 'Email open rate',
  },
  [OPEN_RATE]: { definition: '', learnMoreLink: '', bannerName: 'Open rate (email)' }, // No replacement def since existing HLM definition is generic enough
};
